import {isNotNull} from "../js/util/UtilFunctions";
import {Milestone} from "../services/milestone/MilestoneService";
import "./tradeon-dashboard.scss";

"use strict";

{
    var app = angular.module("tf.tradeOn", [])

                     .controller("openAccountCtrl", ["$rootScope", "$scope", "$state", "$http", "$stateParams", "userConfig", "$uibModal", function openAccountController($rootScope, $scope, $state, $http, $stateParams, userConfig, $uibModal) {
                         $state.userConfig = userConfig;
                     }])

                     .controller("tradeOnCtrl", ["$rootScope", "$scope", "$state", "$http", "$stateParams", "userConfig", "$filter", "terms", "$uibModal", "$localStorage", "$window", "GoogleFeed", "$q", "$timeout", "$interval", "$document", "confirmationService", "confirmationTypes", "gameLoss", "depositCmaHelper", "fxeQuizService", "accountStore", "milestoneStore", "portfolioService",
                         function homeController($rootScope, $scope, $state, $http, $stateParams, userConfig, $filter, terms, $uibModal, $localStorage, $window, GoogleFeed, $q, $timeout, $interval, $document, confirmationService, confirmationTypes, gameLoss, depositCmaHelper, fxeQuizService, accountStore, milestoneStore, portfolioService) {
                             $state.userConfig = userConfig;

                             $scope.vimeoConfig = {
                                 videoId: '265960632'
                             };

                             $scope.takeOptionsQuiz = async () => {
                                 const limit = await marginQuizService.open();
                             };

                             $scope.openAccOpening = function () {
                                 var modalInstance = $uibModal.open({
                                     templateUrl: "app/apps/accOpening/accOpening.tpl.html",
                                     controller: "accOpeningCtrl as accOpeningCtrl",
                                     size: "fs",
                                     windowClass: "accOpenWidth",
                                     resolve: {}
                                 });
                             };

                             $scope.brokerageOffer = function () {
                                 var modalInstance = $uibModal.open({
                                     templateUrl: "app/offers/brokerageOffer/brokerageOffer.tpl.html",
                                     controller: "brokerageOfferCtrl as brokerageOfferCtrl",
                                     size: "lg",
                                     resolve: {}
                                 });
                             };

                             $scope.currentPortfolio = null;

                             $scope.CurrentDate = new Date();

                             $scope.helpers = [
                                 {"name": "optionsCourses"},
                                 {"name": "strategy"},
                                 {"name": "understandOptions"}
                             ];

                             $scope.openTradingPortal = function () {
                                 var modalInstance = $uibModal.open({
                                     templateUrl: "app/apps/tradingPortal/tradingPortal.tpl.html",
                                     controller: "tradingPortalCtrl as tradingPortalCtrl",
                                     size: "lg",
                                     resolve: {}
                                 });
                             };


                             $scope.portfoliosExist = false;

                             var colors = ["#1F77B4", "#DC3912"];

                             $scope.options = {
                                 chart: {
                                     type: "pieChart",
                                     margin: {top: -10},
                                     color: function (d, i) {
                                         return colors[i % colors.length]
                                     },
                                     height: 250,
                                     donut: true,
                                     x: function (d) {
                                         return d.key;
                                     },
                                     y: function (d) {
                                         return d.y;
                                     },
                                     showLabels: false,
                                     showLegend: false,
                                     pie: {
                                         startAngle: function (d) {
                                             return d.startAngle / 2 - Math.PI / 2
                                         },
                                         endAngle: function (d) {
                                             return d.endAngle / 2 - Math.PI / 2
                                         }
                                     },
                                     duration: 500
                                 }
                             };

                             $http.get("/tradefloor/api/sentiment")
                                  .then(function successCallback(response) {
                                      $scope.sentimentData = response.data;
                                      $scope.sentimentChartData = [{
                                          key: "Long",
                                          y: response.data.longVal * 100
                                      }, {key: "Short", y: response.data.shortVal * 100}];
                                  }, function errorCallback(response) {
                                      console.error("errorCallback response: ", response)
                                  });

                             $scope.Math = Math;

                             $scope.strategyBuilder = "ZzPNLlHN9S0";

                             $scope.chartType = "candle";
                             $scope.chartPeriod = {
                                 text: "1 D",
                                 period: 1,
                                 interval: "day",
                                 intraday: false
                             };
                             $scope.chartStudy = {
                                 "Implied Volatility": ""
                             };
                             $scope.chartAttrs = {
                                 layout: {
                                     interval: "day",
                                     periodicity: 1,
                                     chartType: "candle",
                                     crosshair: true
                                 }
                             };

                             $scope.hasScratchAccount = false;
                             $scope.hasRealAccount = true;
                             $scope.hasRealTrade = true;
                             $scope.hasRealFunds = true;

                             $scope.defaultScratchPortfolio = null;
                             $rootScope.defaultPortfolio = null;
                             $scope.portfolios = null;
                             $scope.currentIsSimulated = false;

                             $scope.selectPortfolio = function (portfolio) {
                                 $scope.currentPortfolio = null;

                                 if (portfolio != null) {
                                     $scope.currentPortfolio = portfolio;
                                     $rootScope.defaultPortfolio = portfolio;

                                     if (portfolio.portfolioType === "SIMULATED") {
                                         $scope.defaultScratchPortfolio = portfolio;
                                     }

                                     $scope.showDepositMessage = $scope.currentPortfolio.portfolioType === "BROKER" &&
                                         $scope.hasRealAccount &&
                                         !$scope.hasRealFunds;

                                     var emptyData = {
                                         strategies: []
                                     };

                                     portfolioService.margin(portfolio.id, emptyData).then(function (marginSummary) {
                                         var currentMargin = marginSummary.currentMarginSummary;

                                         $scope.currentMargin = currentMargin;
                                         $scope.eodMarginChange = {
                                             etoLedger: currentMargin.etoLedger - $scope.currentPortfolio.eodMarginSummary.etoLedger,
                                             equityLedger: currentMargin.equityLedger - $scope.currentPortfolio.eodMarginSummary.equityLedger,
                                             cmBalance: currentMargin.cmBalance - $scope.currentPortfolio.eodMarginSummary.cmBalance,
                                             nlv: currentMargin.nlv - $scope.currentPortfolio.eodMarginSummary.nlv,
                                             shortageExcess: currentMargin.shortageExcess - $scope.currentPortfolio.eodMarginSummary.shortageExcess
                                         };
                                     });
                                 }
                             };

                             const portfolioSub = accountStore.current
                                                              .filter(isNotNull)
                                                              .map((account) => account.id)
                                                              .flatMap((id) => portfolioService.portfolio(id))
                                                              .subscribe((portfolio) => $scope.selectPortfolio(portfolio));
                             $scope.$on("$destroy", () => portfolioSub.unsubscribe());

                             $scope.isSimulated = (portfolio) => {
                                 if (portfolio == null) {
                                     return false;
                                 } else {
                                     const type = portfolio.portfolioType;
                                     return type === "SIMULATED" || type === "SCRATCH";
                                 }
                             };

                             $scope.refreshPortfolios = async function () {

                                 const portfolios = await portfolioService.portfolios();

                                 portfolios.forEach((p) => {
                                     p.todayMarginChange = p.clientMargin - p.todayMargin;
                                     p.todayPnlChange = p.pnl - p.todayPnl;

                                     p.weekMarginChange = p.clientMargin - p.weekMargin;
                                     p.weekPnlChange = p.pnl - p.weekPnl;
                                 });

                                 const brokerPortfolios = portfolios.filter((p) => {
                                     return p.portfolioType === "BROKER" || p.portfolioType === "LINKED";
                                 });

                                 const simulated = portfolios.filter((p) => {
                                     return p.portfolioType === "SIMULATED" || p.portfolioType === "SCRATCH";
                                 });

                                 const defaultBrokerPortfolio = brokerPortfolios[0];
                                 const defaultSimulatedPortfolio = simulated[0];

                                 $scope.portfolios = portfolios;
                                 $rootScope.defaultPortfolio = defaultBrokerPortfolio || defaultSimulatedPortfolio;
                                 $scope.defaultScratchPortfolio = defaultSimulatedPortfolio;
                                 $scope.hasScratchAccount = defaultSimulatedPortfolio != null;
                                 $scope.hasRealAccount = defaultBrokerPortfolio != null;
                                 $scope.hasMargin = $scope.hasRealAccount;
                                 $scope.hasRealTrade = brokerPortfolios.some((p) => p.hasTraded);
                                 $scope.hasRealFunds = brokerPortfolios.some((p) => p.totalCash > 0);

                                 // TODO should this be a one off? If so, need a way to go to learn to trade
                                 if (userConfig.branding === 'IV' &&
                                     userConfig.client != null &&
                                     !$scope.hasRealAccount) {

                                     milestoneStore.current
                                                   .take(1)
                                                   .map(m => m.hasCompleted(Milestone.ACC_OPEN_STARTED))
                                                   .filter(started => !started)
                                                   .subscribe(() => {
                                                       if ($localStorage.accountOpeningStarted) {
                                                           delete $localStorage.accountOpeningStarted;
                                                           milestoneStore.completeMilestone(Milestone.ACC_OPEN_STARTED);
                                                       } else {
                                                           $scope.brokerageOffer();
                                                       }
                                                   });
                                 }
                             };

                             $scope.refreshPortfolios();

                             $scope.openEquityTicket = function () {
                                 var modalInstance = $uibModal.open({
                                     templateUrl: "app/portfolio/templates/ticket/ticketEquity.tpl.html",
                                     controller: "ticketEquityCtrl as ticketEquityCtrl",
                                     size: "lg",
                                     resolve: {}
                                 });
                             };

                             $scope.openMultiEquityTicket = function () {
                                 var modalInstance = $uibModal.open({
                                     templateUrl: "app/portfolio/templates/ticket/ticketMultiAccountEquity.tpl.html",
                                     controller: "ticketMultiAccountEquityCtrl as ticketEquityCtrl",
                                     size: "lg",
                                     resolve: {}
                                 });
                             };

                             $scope.openCmaHelper = () => depositCmaHelper.open($scope.currentPortfolio.portfolioId);

                         }]);
}







